






import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ThemeToggle extends Vue {
  private currentTheme: 'light' | 'dark' = 'light';

  mounted() {
    this.updateCurrentTheme();
    this.watchThemeChanges();
  }

  private updateCurrentTheme() {
    this.currentTheme = document.documentElement.classList.contains('dark-theme') ? 'dark' : 'light';
  }

  private watchThemeChanges() {
    const observer = new MutationObserver(() => {
      this.updateCurrentTheme();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  private toggleTheme() {
    if (this.currentTheme === 'light') {
      document.documentElement.classList.add('dark-theme');
      localStorage.setItem('theme-override', 'dark');
    } else {
      document.documentElement.classList.remove('dark-theme');
      localStorage.setItem('theme-override', 'light');
    }
    this.updateCurrentTheme();
  }
}
